<section class="rcx-table">
    <div class="row">
      <div class="col-lg-12">
        <div class="card btr">
          <div class="card-content">
            <div class="card-body table-responsive">
              <form [formGroup]="approvalForm">
                <table class="table" id="table">
                  <thead id="table-thead">
                    <tr class="bg-light">
                      <th scope="col" width="70">#</th>
                      <th scope="col" width="300">Objective</th>
                      <th scope="col" width="300">Key result</th>
                      <th scope="col" width="250">SelfRating</th>
                      <th scope="col" width="300">L 1 Rating</th>
                      <th scope="col" width="300">L 1 Remarks</th>
                    </tr>
                  </thead>
                  <tbody formArrayName="objectives">
                    <tr *ngFor="let approval of objectiveControls.controls; let i = index" [formGroupName]="i">
                      <td>{{i+1}}.</td>
                      <td>{{ approval.value.objective }}</td>
                      <td>{{ approval.value.keyResult }}</td>
                      <td>{{ approval.value.selfRating }}</td>
                      <td>
                        <input type="number" class="form-control" placeholder="L One Rating" 
                               formControlName="loneRating"  [readonly]="isActive"  (keydown.enter)="focusNextField($event)" >
                        <div *ngIf="approval.get('loneRating').invalid && (approval.get('loneRating').dirty || approval.get('loneRating').touched)">
                          <small class="text-danger" *ngIf="approval.get('loneRating').errors?.required">L One Rating is required.</small>
                          <small class="text-danger" *ngIf="approval.get('loneRating').errors?.pattern">L One Rating must be 0.1 to 1</small>
                        </div>
                      </td>                     
                    <td>
                        <input type="text" class="form-control" placeholder="L One Remarks" 
                       formControlName="loneRemarks"  [readonly]="isActive"  (keydown.enter)="focusNextField($event)">
                       <div *ngIf="approval.get('loneRemarks').invalid && (approval.get('loneRemarks').dirty || approval.get('loneRemarks').touched)">
                        <small class="text-danger" *ngIf="approval.get('loneRemarks').errors?.required">L One Remarks is required.</small>
                        <small class="text-danger" *ngIf="approval.get('loneRemarks').errors?.pattern">Only letters allowed</small>
                      </div>
                    </td>              
                    </tr>
                  </tbody>
                </table>
              </form> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  